/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SolicitacoesPendentesAliases {
  AVATAR_BENEFICIARIO = 'avatar-beneficiario',
  AVATAR_SEGURADO = 'avatar-segurado',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_0 = 'deck-0',
  DECK_DOIS = 'deck-dois',
  DETALHES_GUIA = 'detalhes-guia',
  DETALHES_REQUISICAO = 'detalhes-requisicao',
  FETCH_CONSULTA = 'fetch-consulta',
  FETCH_CONSULTA_DOIS = 'fetch-consulta-dois',
  FIELD_BENEFICIARIO = 'field-beneficiario',
  FIELD_BENEFICIARIO_DOIS = 'field-beneficiario-dois',
  FIELD_DATA_SOLIC = 'field-data-solic',
  FIELD_DATA_SOLIC_DOIS = 'field-data-solic-dois',
  FIELD_GUIA = 'field-guia',
  FIELD_GUIA_DOIS = 'field-guia-dois',
  FIELD_TIPO_GUIA = 'field-tipo-guia',
  FIELD_TIPO_GUIA_DOIS = 'field-tipo-guia-dois',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  HPMS_CUSTOM_CARD_DOIS = 'hpms-custom-card-dois',
  HPMS_DYNAMIC_CONTENT_INTERCAMBIO = 'hpms-dynamic-content-intercambio',
  HPMS_DYNAMIC_CONTENT_SITUACAO = 'hpms-dynamic-content-situacao',
  HPMS_DYNAMIC_CONTENT_VISUALIZADA = 'hpms-dynamic-content-visualizada',
  MAPPER_BENEFICIARIO = 'mapper-beneficiario',
  MAPPER_SEGURADO = 'mapper-segurado',
  PANEL_CASO_DOIS = 'panel-caso-dois',
  PANEL_CASO_UM = 'panel-caso-um',
  PANEL_SOLIC_PENDENTES = 'panel-solic-pendentes',
  TEXT_DATA_SOLIC = 'text-data-solic',
  TEXT_DATA_SOLIC_DOIS = 'text-data-solic-dois',
  TEXT_GUIA = 'text-guia',
  TEXT_GUIA_DOIS = 'text-guia-dois',
  TEXT_TIPO_GUIA = 'text-tipo-guia',
  TEXT_TIPO_GUIA_DOIS = 'text-tipo-guia-dois',
}
export { SolicitacoesPendentesAliases };
